import { Reducer } from 'redux';
import { set, flow } from 'lodash/fp';

import { LoginActionTypes } from '../../../auth/login/store/types';
import { SystemMaintenanceState, SystemMaintenanceTypes } from './types';

export const INITIAL_STATE: SystemMaintenanceState = {
    isSaving: false,
    currentSystemMaintenanceSections: []
};

export const systemMaintenanceReducer: Reducer<SystemMaintenanceState> = (state = INITIAL_STATE, { payload, type }): SystemMaintenanceState => {
    switch (type) {
        case SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_STARTED:
            return set('isSaving', true, state);
        case SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_SUCCESSFUL:
        case SystemMaintenanceTypes.FETCH_SYSTEM_MAINTENANCE_SUCCESSFUL:
            return flow(
                set('currentSystemMaintenanceSections', payload),
                set('isSaving', false)
            )(state);
        case SystemMaintenanceTypes.SAVE_SYSTEM_MAINTENANCE_FAILED:
            return set('isSaving', false, state);
        case LoginActionTypes.LOGOUT_SUCCESSFUL:
            return INITIAL_STATE;
        default:
            return state;
    }
};
